import * as React from "react";

import { api } from "@repo/backend";
import { Skeleton } from "@repo/ui/components/skeleton";
import { createFileRoute, Navigate, Outlet, useRouterState } from "@tanstack/react-router";
import { useQuery } from "convex/react";

export const Route = createFileRoute("/_authed/staff-photo-shoots")({
  head: () => ({ meta: [{ title: "Staff Photo Shoots" }] }),
  component: StaffPhotoShootsRoute,
});

function StaffPhotoShootsRoute() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const overview = useQuery(api.scheduling.getAdminSchedulingOverview);

  if (pathname !== "/staff-photo-shoots") return <Outlet />;
  if (!overview) return <Skeleton className="m-3 h-[calc(100svh-5rem)] rounded-xl" />;

  const today = new Date().toLocaleDateString("sv-SE");
  const date =
    overview.activeDates.find((activeDate) => activeDate >= today) ??
    overview.activeDates.at(-1) ??
    today;

  return (
    <React.Fragment>
      <Navigate to="/staff-photo-shoots/$date" params={{ date }} replace />
    </React.Fragment>
  );
}
